import { Card } from '../components/Card';
import { useContent } from '../data/ContentContext';
import './pages.css';

export function ContributionsPage() {
  const { contributionsContent } = useContent();
  const { platform, components, framework } = contributionsContent;

  return (
    <div className="page">
      <Card title={platform.title} icon={platform.icon}>
        <div className="contrib-grid contrib-grid--2">
          {platform.items.map((item) => (
            <div className="contrib-tile" key={item.title}>
              <div className="contrib-tile__head">
                <span className="contrib-tile__name">{item.title}</span>
                <span className="contrib-tile__badge">{item.badge}</span>
              </div>
              <p className="contrib-tile__desc">{item.description}</p>
            </div>
          ))}
        </div>
      </Card>

      <Card title={components.title} icon={components.icon}>
        <div className="contrib-grid contrib-grid--3">
          {components.items.map((item) => (
            <div className="contrib-tile" key={item.title}>
              <span className="contrib-tile__name">{item.title}</span>
              <p className="contrib-tile__desc">{item.description}</p>
            </div>
          ))}
        </div>
      </Card>

      <Card title={framework.title} icon={framework.icon} variant="framework">
        <div className="contrib-steps">
          {framework.steps.map((item) => (
            <div className="contrib-step" key={item.step}>
              <span className="contrib-step__num">{item.step}</span>
              <span className="contrib-step__label">{item.label}</span>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
